import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { ToastService } from '.';
import { GeneralMail } from '../shared/configurable-mail/general-mail-model';
import { ModuleTypes } from '../shared/module-types';
import { EmailApi, EmailMessage, ExitEmailMessage, ImmigrationEmailMessage } from './api.gen';
import { AuthService } from './auth.service';
import { CommonService } from './common.service';
import { DialogService } from './dialog.service';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class ShareDocumentService {

  constructor(private common: CommonService,
    private emailAPI: EmailApi,
    private dialog: DialogService,
    private loader: LoaderService,
    public authService: AuthService,
    private modalService: NgbModal,
    private toast: ToastService) { }

  formMsg(emailAddresses) {
    var msg = "";
    var emailAddr = emailAddresses.split(";");
    for (var i = 0; i < emailAddr.length; i++) {
      msg += "<div>" + emailAddr[i] + "</div>";
    }
    return msg;
  }

  confirmMsg(email) {
    var confirmMsg = "<div>Do you want to send the mail to the following recipient/s?</div>";
    confirmMsg += this.formMsg(email.toAddresses);
    confirmMsg += this.formMsg(email.cc);
    return confirmMsg;
  }

  mapToGeneralMail(em) {
    let emailShare = new GeneralMail();
    emailShare.toAddresses = em.toAddresses;
    emailShare.cc = em.cc;
    emailShare.content = em.content;
    emailShare.fromAddresses = em.fromAddresses;
    emailShare.subject = em.subject;
    emailShare.attachments = [];
    return emailShare;
  }

  confirmModal(email, moduleType) {
    this.dialog.showConfirmationBox("Confirmation message",
      this.confirmMsg(email), () => {
        email = this.mapToMail(email, moduleType);
        this.loader.show();
        this.sendMail(email, moduleType);
      }, () => { }, true);
  }

  mapToMail(email, moduleType) {
    var emailMsg;
    switch (moduleType) {
      case ModuleTypes.Immigration:
        emailMsg = new ImmigrationEmailMessage();
        break;
      case ModuleTypes.Preboarding:
        emailMsg = new EmailMessage();
        break;
      default:
        emailMsg = new ExitEmailMessage();
        break;
    }
    emailMsg.cc = email.cc;
    emailMsg.bcc = email.bcc;
    emailMsg.candidateDocuments = email.uploadedFiles;
    emailMsg.attachments = email.attachments;
    emailMsg.content = email.content;
    emailMsg.fromAddresses = this.authService.ActiveUser.email;
    emailMsg.subject = email.subject;
    emailMsg.toAddresses = email.toAddresses;
    emailMsg.activityTemplateId = email.activityTemplateId;
    return emailMsg;
  }

  sendMail(emailMsg, moduleType) {
    switch (moduleType) {
      case ModuleTypes.Immigration:
        this.emailAPI.sendImmigrationMail(this.common.immigrationProfileId, emailMsg).pipe(finalize(() => {
          this.loader.clear();
        })).subscribe(() => {
          this.modalService.dismissAll();
          this.toast.success("Email sent successfully");
        });
        break;
      case ModuleTypes.Preboarding:
        this.emailAPI.sendMail(this.common.candidateId, emailMsg).pipe(finalize(() => {
          this.loader.clear();
        })).subscribe(() => {
          this.modalService.dismissAll();
          this.toast.success("Email sent successfully");
        });
        break;
      default:
        this.emailAPI.sendExitMail(this.common.exitProfileId, emailMsg).pipe(finalize(() => {
          this.loader.clear();
        })).subscribe(() => {
          this.modalService.dismissAll();
          this.toast.success("Email sent successfully");
        });
        break;
    }
  }
  changeDocumentName(docs, moduleType) {
    switch (moduleType) {
      case ModuleTypes.Preboarding:
        docs.forEach(doc => {
          const str = doc.fileName.split(".");
          doc.fileName = doc.documentName.replace("GPN_", '') + "." + str[str.length - 1];
        });
        break;
      case ModuleTypes.Immigration:
        docs.forEach(doc => {
          const str = doc.fileName.split(".");
          if (doc.dependentId !== null && doc.dependentId !== 0 && doc.dependentName !==null) {
            doc.documentName = doc.documentName + '_' + doc.dependentName;
          }
          doc.fileName = doc.documentName.replace("GPN_", '') + "." + str[str.length - 1];
        });
        break;
      default:
        docs.forEach(doc => {
          const str = doc.fileName.split(".");
          doc.fileName = doc.documentName.replace("GPN_", '') + "." + str[str.length - 1];
        });
        break;
    }
    return docs;
  }

  isFileAvailable(docs) {
    if (docs.length > 0) {
      return true;
    } else {
      this.toast.warning("No files to share");
      return false;
    }
  }
}
